import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import dragDirective from './uitls/drag';
import longpress from './uitls/longpress';

// import { createCompat } from '@vue/compat'

import protobuf from 'protobufjs'
import Long from 'long'

import visibility from 'vue-visibility-change'
import i18n from './i18n'

protobuf.util.Long = Long;
protobuf.configure();
if (process.env.NODE_ENV == 'production') {
  console.log = function () { }
}

import {
  Button,
  Lazyload,
  Tabbar,
  Sticky,
  NavBar,
  Icon,
  Image,
  Tabs,
  Tab,
  Toast,
  Field,
  Swipe,
  Form,
  SwipeItem,
  Checkbox,
  CheckboxGroup,
  PullRefresh,
  TabbarItem,
  Cell,
  CellGroup,
  List,
  Loading,
  Circle,
  ActionSheet,
  Collapse,
  CollapseItem,
  Badge,
  IndexBar,
  IndexAnchor,
  NoticeBar,
  Overlay,
  Calendar,
  Search,
  Divider,
  Uploader,
  Locale,
  SwipeCell,
  Dialog,
  Pagination,
  Switch,
  CountDown,
  Popup
} from "vant";
import "vant/lib/index.css";
import thTh from 'vant/es/locale/lang/th-TH';
import enTh from 'vant/es/locale/lang/en-US';
import Socket from "@/network/socket/socket";
import { ApiNetWork } from "@/network/apiNet/apiNet";
import { YMPush } from "./uitls/uitls";
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn' // +
import 'dayjs/locale/th'

const app = createApp(App);
// createCompat(app) // 安装 @vue/compat 适配器
const th = process.env.VUE_APP_Language as string;
window.$Socket = Socket;
window.$apiNet = ApiNetWork;
YMPush("APP", "启动")
if (th == 'th') {
  Locale.use('en-US', thTh);
  dayjs.locale('th') // +
} else if(th == 'id'){
  Locale.use('en-US', enTh);
  dayjs.locale('id') // +
} else {
  dayjs.locale('zh-cn') // +
}
app
  .use(router)
  .use(i18n)
  .use(store)
  .use(Button)
  .use(Lazyload, {
    lazyComponent: true,
  })
  .use(Tabbar)
  .use(Sticky)
  .use(Uploader)
  .use(NavBar)
  .use(Icon)
  .use(Image)
  .use(Tabs)
  .use(Tab)
  .use(Divider)
  .use(Toast)
  .use(TabbarItem)
  .use(Field)
  .use(Form)
  .use(Swipe)
  .use(SwipeItem)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(PullRefresh)
  .use(CellGroup)
  .use(Cell)
  .use(List)
  .use(Loading)
  .use(Circle)
  .use(ActionSheet)
  .use(Collapse)
  .use(CollapseItem)
  .use(Badge)
  .use(IndexAnchor)
  .use(IndexBar)
  .use(NoticeBar)
  .use(Overlay)
  .use(Search)
  .use(Calendar)
  .use(SwipeCell)
  .use(visibility)
  .use(Dialog)
  .use(Switch)
  .use(CountDown)
  .use(Popup)
  .directive('drag', dragDirective)
  .directive('longpress', longpress);
  app.mount("#app");


